/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Esempio { 
    request_time?: string;
    path?: string;
    query_string?: string;
    actor_type?: string;
    user_agent?: string;
    durata_ms?: number;
    request_body?: string;
    response_body?: string;
    allegati?: string;
}

